import IconBase from "./IconBase";

const CorrectIcon = (props) => (
    <IconBase {...props}>
        <path d="M5 12.5l4.5 4.5L19 7.5" />
    </IconBase>
);

export default CorrectIcon;
